import React, { Fragment, useEffect, useState } from "react";
import LinkCommonComponent from "../common/LinkCommonComponent";

const cardData = [
  { icon: "/img/desktop/icons/white-profile-icon.svg", name: "Client" },
  {
    icon: "/img/desktop/icons/white-three-people-icon.svg",
    name: "Agency (Dev Firm)",
  },
];
export default function WelcomeSelect() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    localStorage.setItem("typeOfCompany", activeIndex);
  }, [activeIndex]);

  /*===========================================
                handleSelect
===========================================*/
  const handleSelect = (index) => {
    setActiveIndex(index);
    localStorage.setItem("typeOfCompany", index);
  };

  /*===========================================
                renderLeftBlock
===========================================*/
  const renderLeftBlock = () => {
    return (
      <div className="welcome-select-left-section">
        <h4 className="font-36-nunito-semibold">
          Expand your business and reach.{" "}
        </h4>
        <p className="font-18-nunito-light pt-25">
          Lorem ipsum dolor sit amet, consectetur adipiscing
          <br /> elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua.{" "}
        </p>
      </div>
    );
  };

  /*===========================================
               renderCard 
===========================================*/
  const renderCard = () => {
    return (
      <>
        {cardData.map((data, index) => (
          <Fragment key={index}>
            <div
              className={
                activeIndex === index
                  ? "client-and-agency-card client-and-agency-card--active"
                  : "client-and-agency-card"
              }
              onClick={() => handleSelect(index)}
            >
              <div className="client-and-agency-card--icon-text-div">
                <div className="client-and-agency-card--icon-div">
                  <img
                    src={data.icon}
                    alt="client"
                    className="client-and-agency-card--icon"
                  />
                </div>
                <h5 className="font-24-nunito-semibold">{data.name}</h5>
              </div>
              {activeIndex === index ? (
                <img
                  // src={"/img/desktop/icons/white-profile-icon.svg"}
                  src={"/img/desktop/icons/gradient-right-arrow.png"}
                  alt="right arrow"
                  className="client-and-agency-card--right-arrow"
                />
              ) : (
                ""
              )}
            </div>
          </Fragment>
        ))}
      </>
    );
  };

  /*=====================================================

                      return

  =======================================================*/
  return (
    <div className="mt-auth-platform-bg">
      <div className="custom-d-flex flex-nowrap">
        {renderLeftBlock()}
        <div className="welcome-select-right-section">
          <h2 className="font-48-nunito-semibold purple-green-gradient-text">
            Welcome
          </h2>
          <p className="font-24-nunito-semibold welcome-select-choose-company-text">
            Choose your type of company
          </p>
          {renderCard()}

          <LinkCommonComponent
            linkPath="/welcome"
            linkText="Login"
            extraClassName="welcome-select-login-btn"
          />
        </div>
      </div>
    </div>
  );
}
